export default defineNuxtPlugin((nuxtApp) => {
    if (document.getElementById("cookieyes")) return
    
    const id = nuxtApp.$config.public.cookieYesId
    const featureEnabled = nuxtApp.$config.public.features.cookieConsent
    
    if(!featureEnabled) {
        console.warn("Consent feature is not enabled")
        return;
    } else if(!id) {
        console.warn("CookieYes ID is not defined")
        return;
    }
    
    const script = document.createElement("script")
    script.id = "cookieyes"
    script.type = "text/javascript"
    script.src = `https://cdn-cookieyes.com/client_data/${id}/script.js`

    document.head.appendChild(script)
})
